import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getPredictionHorseSlice = createSlice({
    name: 'PredictionOfHorse',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchPredictionHorse.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchPredictionHorse.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchPredictionHorse.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setPredictionRace, setStatus } = getPredictionHorseSlice.actions;
export default getPredictionHorseSlice.reducer;

export const fetchPredictionHorse = createAsyncThunk('/PredictionHorseget/fetch', async () => {
    const res = await axios.get(`${getBaseUrl()}/RacePredictorv2`);
    const PredictionHorseData = res.data;
    return PredictionHorseData.data;
})